export default "__VITE_ASSET__d6392eb9__"